import { BillOfQuantititesStep } from '../types/bill-of-quantities-step';

// step 0 (upload) has no route for an existing bill of quantities
type BillOfQuantitiesRoutableStep = Exclude<BillOfQuantititesStep, 0>;

const STEP_ROUTE_MAP: Readonly<Record<BillOfQuantitiesRoutableStep, string>> = {
  1: 'review',
  2: 'suggestions',
  3: 'summary',
};

/**
 * Route segment for the step a bill of quantities is currently at, to be used with relative
 * navigation (e.g. `router.navigate(['../create', billOfQuantitiesId, segment], { relativeTo })`).
 * @param step the current step of the bill of quantities
 * @returns the route segment for that step, or `null` if the step has no route (step 0)
 */
export function getBillOfQuantitiesStepSegment(step: BillOfQuantititesStep): string | null {
  return step === 0 ? null : STEP_ROUTE_MAP[step];
}
